import { sort } from 'ramda'

const getName = ({ name }) => name || ' '
const nameComparator = (a, b) => getName(a).localeCompare(getName(b))
export const sortByName = (organizations) => sort(nameComparator, organizations)

export const getAuthorizationType = (scopes) => {
  if (scopes.includes('org_admin')) {
    return 'Admin'
  }
  else if (scopes.includes('calendar_user')){
    return 'Calendar User'
  }
  return 'Chat User'
}



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/AppSwitcher/Organizations/utils.js